import { Inertia } from '@inertiajs/inertia';
import { usePage } from '@inertiajs/inertia-react';
import { useFormik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

export default function SignInPage() {
  const { errors } = usePage().props;

  const { values, setFieldValue, handleSubmit, isValid } = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    isInitialValid: false,
    enableReinitialize: true,
    validationSchema,
    onSubmit,
  });

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="px-10 text-indigo-600 sm:mx-auto sm:w-full sm:max-w-md">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5439.6 1882" className="py-3">
          <path
            fill="currentColor"
            d="M1760.6 1603.5c-9.5 136.9-22.1 186.4-101 186.4-22.1 0-69.4-8.8-104.1-8.8-22.1 0-28.4 14.6-28.4 29.1s6.3 26.2 28.4 26.2c116.7 0 274.5-5.8 520.6-5.8 280.8 0 508 5.8 627.9 5.8 18.9 0 28.4-11.7 28.4-26.2 0-11.7-9.5-26.2-28.4-26.2-25.2 0-60 5.8-75.7 5.8-78.9 0-94.6-49.5-101-186.4-6.3-203.9-15.8-498.1-15.8-789.4 0-203.9 3.1-410.7 15.8-582.6 6.3-93.2 12.6-183.5 91.5-183.5 31.5 0 63.1 8.7 85.2 8.7 18.9 0 28.4-17.5 28.4-29.1 0-14.6-9.5-26.2-28.4-26.2-151.4 0-334.4 11.6-508 11.6-208.2 0-290.3-11.6-416.5-11.6-85.2 0-97.8 23.3-107.3 75.7-53.6 335-104.1 501-173.5 745.7-28.4 99-50.5 160.2-101 160.2-47.3 0-75.7-55.4-116.7-218.5-44.2-168.9-97.8-512.6-113.6-672.8-9.5-72.8-31.6-90.3-91.5-90.3-183 0-271.3 11.6-533.2 11.6-148.3.2-350.2-11.5-514.3-11.5C9.5 1.4 0 13.1 0 27.7c0 11.6 9.5 29.1 28.4 29.1 22.1 0 53.6-8.7 85.2-8.7 104.1 0 119.9 102 119.9 215.5 0 763.2-69.4 1337-189.3 1485.6-28.4 37.9-41 43.7-41 64.1 0 14.6 9.5 23.3 25.3 23.3 56.8 0 154.6-5.8 280.8-5.8 186.1 0 287.1 5.8 350.2 5.8 22.1 0 31.5-17.5 31.5-26.2 0-20.4-9.5-29.1-72.6-84.5-224-195.2-337.6-681.6-337.6-1208.8 0-75.8 3.2-142.7 47.3-142.7 28.4 0 50.5 32 75.7 81.6 119.9 235.9 331.3 923.4 429.1 1255.4 31.5 107.8 41 122.3 249.3 122.3 217.7 0 252.4-14.6 274.5-122.3 88.4-436.9 208.3-996.2 293.4-1235.1 28.4-75.8 59.9-110.7 85.2-110.7 44.1 0 47.3 40.8 47.3 128.2 0 637.8-9.4 943.7-22 1109.7M3912.3 684.5c0-291.3 50.5-469 148.3-469 72.6 0 101 78.6 189.3 387.4 75.7 259.2 113.6 416.5 113.6 515.6 0 52.4-22.1 87.4-170.4 87.4-214.6 0-280.8-26.2-280.8-521.4m-154.7 1133.1c97.8 0 309.3 20.4 350.3 20.4 25.3 0 37.9-17.5 37.9-40.8 0-78.6-132.5-282.5-132.5-457.3 0-67 34.7-93.2 189.3-93.2 186.2 0 208.3 23.3 208.3 326.2 0 145.6-31.6 218.5-85.2 218.5-31.6 0-56.8-8.7-78.9-8.7-18.9 0-31.5 11.6-31.5 29.1 0 14.6 6.3 26.2 31.5 26.2 41 0 460.7-14.6 643.8-14.6 224 0 438.6 14.6 527 14.6 15.8 0 22.1-11.6 22.1-26.2 0-11.6-6.3-23.3-15.8-46.6-202-364.1-495.4-1293.3-495.4-1712.8 0-34.9-22.1-49.5-53.7-49.5-60 0-306.1 17.5-571.2 17.5C4092.1 20.4 3498 0 3390.8 0c-25.2 0-34.7 14.6-34.7 29.1 0 14.6 9.5 32.1 34.7 32.1 37.9 0 294.3-11.7 335.3-11.7 91.5 0 179.9 29.1 179.9 206.8 0 375.7-558.5 1147.7-558.5 1529.3 0 40.8 25.3 52.4 69.4 52.4 69.4 0 211.3-20.4 340.7-20.4M2892.1 1757.7h335.4v-49.4h-379.9V1882h44.5v-124.3zm58.6-167.7v-123.7l195.9 62.4-195.9 61.3zm-103.1 87.4l379.9-131.3v-35.8l-379.9-130.8v52.1l58.1 19.5v154.1l-58.1 20.1v52.1zm379.9-238.9v-52.1l-298.5-98.2 298.5-98.8v-52.1l-379.9 133v35.8l379.9 132.4zm-379.9-342.2h379.9v-51h-379.9v51zm0-237.4v49.4H3183v98.8h44.5V760.6H3183v98.2h-335.4zm121-360.9c-80.9 0-129.7 58.1-129.7 131.3 0 72.2 40.2 128.6 114.5 128.6 73.8 0 96.6-67.8 115.6-126.4 10.9-36.4 24.4-70.6 65.7-70.6 35.3 0 57 28.2 57 70 0 42.3-28.2 68.4-71.6 68.9v49.4c70-.6 116.1-50.5 116.1-119.4 0-68.4-41.2-118.3-101.5-118.3-77.1 0-96.1 56.4-117.8 124.8-9.8 33.1-22.8 72.2-68.9 72.2-39.6 0-64.6-31.5-64.6-75.4 0-51.5 33.1-85.8 85.2-85.8V498zm214.4-26h44.5V258.6h-379.9V472h44.5V308h122.1v164h44.5V308H3183v164zm0-257.2h44.5V1.4h-379.9v49.4h155.2v163.9h44.5V50.8H3183v164z"></path>
        </svg>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="username"
                className="block text-sm font-medium leading-5 text-gray-700">
                Username
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  onChange={(event) => setFieldValue('username', event.target.value)}
                  value={values.username}
                  id="username"
                  type="username"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>

            <div className="mt-6">
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-5 text-gray-700">
                Password
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  onChange={(event) => setFieldValue('password', event.target.value)}
                  value={values.password}
                  id="password"
                  type="password"
                  required
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>

            <div className="mt-6">
              <span className="block w-full rounded-md shadow-sm">
                <button
                  type="submit"
                  className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                  Sign in
                </button>
              </span>
            </div>
            {!!errors && (
              <div className="mt-3">
                <p className="text-sm text-red-700">
                  No user was found for this username and password combination.
                </p>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );

  function onSubmit(values: { username: string; password: string }) {
    Inertia.post('/sessions', values);
  }
}

const validationSchema = Yup.object({
  username: Yup.string().required('Please provide a username.'),
  password: Yup.string().required('Please provide a password.'),
});
